export const currencyList = [
  {
    value: 'KZT',
    text: 'KZT',
  },
  {
    value: 'RUB',
    text: 'RUB',
  },
  {
    value: 'USD',
    text: 'USD',
  },
  {
    value: 'EUR',
    text: 'EUR',
  },
  {
    value: 'GBR',
    text: 'GBR',
  },
  {
    value: 'CNY',
    text: 'CNY',
  },
];
